import { getCookie } from '@helper/functions';
import api from './axios';

const baseUrl = import.meta.env.VITE_API_URL;

export const getStatisticsAgent = async (advertiser) => {
  const res = await api.get(`admin/agents/count/${advertiser}`);
  return res.data.data;
};

export const getAgent = async () => {
  const res = await api.get(`agents.json`);
  return {
    results: res.data.results,
    data: res.data.data.data,
    totalAgents: res.data.totalAgents,
  };
};

export const getAds = async (realState, filter, page = 1, limit = 5, search = '', sort = 'newest') => {
  const res = await api.get(`ad.json`);
  return {
    results: res.data.results,
    data: res.data.data.data,
    totalAds: res.data.totalAds,
    totalPages: res.data.totalPages,
  };
};

export const getAdsByAgent = async (id, filter, page = 1, limit = 5) => {
  const res = await api.get(`ad.json`);
  return {
    results: res.data.results,
    data: res.data.data.data,
    totalAds: res.data.totalAds,
    totalPages: res.data.totalPages,
  };
};

export const getOneAgent = async (realState) => {
  const res = await api.get(`agent_one.json`);
  return res.data.data.data;
};

export const getOneAds = async (id) => {
  const res = await api.get(`ad_one.json`);
  return res.data.data.data;
};

export const getUser = async () => {
  const res = await api.get(`user.json`);
  return res.data;
};

export const deleteAds = async (idList) => {
  const res = await api.delete(`ads`, {
    data: { idList },
  });
  return res.data.data;
};

export const draftAds = async (idList) => {
  const res = await api.put(`admin/ads/draft`, { idList });
  return res.data.data;
};

export const pinAds = async (idList) => {
  const res = await api.put(`admin/ads/pin`, { idList });
  return res.data.data;
};

export const deleteAgent = async (id) => {
  const url = `${baseUrl}/api/admin/agents/${id}`;

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${getCookie('accessToken')}`,
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok: ' + response.statusText);
    }

    const data = await response.json();

    // Assuming the structure of the response
    return data?.data || data;
  } catch (error) {
    return null;
  }
};

export const changeSettings = async (realState, input) => {
  await api.put(`admin/realState/${realState}`, input);
};

export const changeLogoSettings = async (realState, input) => {
  const formData = new FormData();
  formData.append('profile', input);
  await api.put(`admin/realState/images/${realState}`, formData);
};

export const changeProfileAgent = async (profilePicture = '', id) => {
  const formData = new FormData();
  formData.append('profilePicture', profilePicture);
  await api.put(`admin/agents/images/${id}`, formData);
};

export const deleteProfileAgent = async (profilePicture, banner, id) => {
  const data =
    profilePicture && banner
      ? {
          deleteBanner: 'true',
          deleteProfile: 'true',
        }
      : profilePicture && !banner
        ? {
            deleteProfile: 'true',
          }
        : !profilePicture &&
          banner && {
            deleteBanner: 'true',
          };

  await api.put(`admin/agents/deleteImages/${id}`, data);
};

export const signUpAgent = async (data, id) => {
  const cookieaccess = await getCookie('accessToken');

  return fetch(`${baseUrl}/api/admin/agents/complete/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${cookieaccess}`,
      'Content-Type': 'application/json; charset=utf-8', // Set the content type to JSON
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};

export const signUpRealestate = async (data, id) => {
  const cookieaccess = await getCookie('accessToken');

  return fetch(`${baseUrl}/api/admin/realState/${id}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${cookieaccess}`,
    },
    body: data,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};

export const sendOtp = (phoneNumber) => {
  const data = { phoneNumber };

  return fetch(`${baseUrl}/api/auth/send-code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Set the content type to JSON
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};

export const checkOtp = (phoneNumber, code) => {
  const data = { phoneNumber, code };

  return fetch(`${baseUrl}/api/auth/verify-code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8', // Set the content type to JSON
    },
    // credentials: "include",
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => data);
};

export const getRealState = async (realState) => {
  const res = await api.get(`realstate.json`);
  return res.data;
};

export const getViews = async () => {
  const res = await api.get(`views.json`);
  return res.data;
};

export const getNewTokens = async () => {
  try {
    const res = await api.post(`auth/refreshToken`, {
      token: getCookie('refreshToken'),
    });
    return res.data.token;
  } catch (error) {
    return null;
  }
};

export const logout = async () => {
  try {
    await api.post(`auth/logout`);
  } catch (error) {
    return null;
  }
};

export const accept = async (status, id) => {
  const cookieaccess = await getCookie('accessToken');

  return fetch(`${baseUrl}/api/admin/notification/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${cookieaccess}`,
      'Content-Type': 'application/json; charset=utf-8', // Set the content type to JSON
    },
    body: JSON.stringify({
      status: status,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => data);
};
